import { API_ROOT } from 'packages/http_client/utils';

const INVOICE_API = `${API_ROOT}/invoice`;

export default INVOICE_API;
